import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'resource:data.dimensions.healthCheck',
    'resource:data.dimensions.healthCheck.attributes.score',
    'resource:data.dimensions.healthCheck.attributes.weight',
    'resource:data.dimensions.healthCheck.entities.assessment',
    'resource:data.dimensions.healthCheck.entities.criteria',
    'resource:data.dimensions.healthCheck.entities.criteria.attributes.approachScore',
    'resource:data.dimensions.healthCheck.entities.criteria.attributes.correctiveActions',
    'resource:data.dimensions.healthCheck.entities.criteria.attributes.deploymentScore',
    'resource:data.dimensions.healthCheck.entities.criteria.attributes.evidenceRequired',
    'resource:data.dimensions.healthCheck.entities.criteria.attributes.evidenceUsed',
    'resource:data.dimensions.healthCheck.entities.criteria.attributes.observations',
    'resource:data.dimensions.healthCheck.entities.criteria.attributes.scoreReason',
    'resource:data.dimensions.healthCheck.entities.dimension',
    'resource:data.dimensions.healthCheck.entities.track',
    'resource:solutions.apps.organizationHealthCheck',
    'resource:solutions.apps.organizationHealthCheck.pages.details',
    'resource:solutions.apps.organizationHealthCheck.pages.overview',
    'resource:solutions.mosaic.pages.organizationHealthCheck.details',
    'resource:solutions.mosaic.pages.organizationHealthCheck.overview',
    'resource:solutions.mosaic.widgets.organizationHealthCheck.healthCheckTable',
    'resource:solutions.mosaic.widgets.organizationHealthCheck.trackScoreDetails',
  ],
  description:
    'Visualize results of an organizational health check related to strategic planning.',
  name: 'Organization Health Check',
} as const satisfies core.quiver.Package
